// extracted by mini-css-extract-plugin
export default {"paginationDiv":"Pagination_paginationDiv__qvjsM","paginationText":"Pagination_paginationText__lGH6Z"};